// Bouwt een interne Gripp-webapp-deeplink naar een offerte (opent direct het
// offerte-record in de Gripp-interface; alleen voor ingelogde Gripp-gebruikers).
//
// LET OP: dit is Gripp's ONGEDOCUMENTEERDE interne URL-formaat — het fragment na
// '#' is base64-JSON met Gripp-UI-node-IDs. Alleen `recordid` (offerte-id) en
// `selectedrelatie` (klant-id) worden ingevuld; de rest is boilerplate grid-state.
// Werkt zolang Gripp de schermopbouw niet wijzigt; makkelijk te herstellen als wel.
import { leesJson } from './apiFout';

const GRIPP_BASE = 'https://full-frame.gripp.com/public/index.php';

const GRID_DEFAULTS = {
  defaultgridpreset: null, sg_: false, i_: 50, customgridfilter: null,
  renderingmode: 'asrows', cp_: 1, currentpage_infinitescroll: 1, sr_: [], ss_: '',
  showIntermediateHeader: null, toonomschrijving: false, ob_: [],
  showstarredemployees: true, shownotstarredemployees: true, showtags: true,
  fixedcolumnwidths: false, columnordering: [], columnvisibility: [],
};

// Deeplink naar een PROJECT-record (zelfde ongedocumenteerde formaat; structuur
// ontleend aan een echte project-URL, juli 2026). recordid is hier een STRING.
export function buildGrippProjectUrl(projectGrippId, companyId) {
  const rid = Number(projectGrippId);
  if (!rid) return null;
  const state = {
    action: 'viewSubpage',
    actionparams: {
      sn_: {
        n6409n: { selectedtab: 'n15338n' },
        n30719n: { toekomst: false, widgets: { 11: [[], [], [], [], [], [], [], [], [], [], [], [], []], 12: [], 13: [], 14: [], 17: [], 18: [], 19: [], 20: [], 22: { tab: 'uren', grouping: 'onderdeel' }, 402: [], 404: [] } },
        n9352n: { i_: 10000, cp_: 1, sr_: [] },
        n16459n: { selectedrelatie: Number(companyId) || 0 },
        n24833n: { ...GRID_DEFAULTS, ob_: [{ n24837n: 'asc' }] },
        ne2941ddfn: { intervalsshowing: 6, agendamode: 'week', date_start: '', showcompleted: false, shownotinscope: true, filterphrase: '' },
        n17756n: { ...GRID_DEFAULTS, dashboard_groep_id: null, dashboard_onderdeel_id: null, dashboard_grouping: null },
        n41352n: { ...GRID_DEFAULTS },
        n26106n: { ...GRID_DEFAULTS },
        n16401n: { ...GRID_DEFAULTS },
        n48951n: { entityfilter: null, typefilter: null },
        n17621n: { selectedemployee: { r_: '100' }, cp_: 1, i_: 12 },
        n9098n: { recordid: String(rid), o_: 'view', pinned: [], showpinnedonly: [] },
      },
      re_: 'n9102n',
    },
  };
  const b64 = btoa(unescape(encodeURIComponent(JSON.stringify(state))));
  return `${GRIPP_BASE}?u=100#${b64}`;
}

export function buildGrippOfferUrl(offerId, companyId) {
  const rid = Number(offerId);
  if (!rid) return null;
  const state = {
    action: 'viewSubpage',
    actionparams: {
      sn_: {
        n20332n: { selectedtab: 'n20333n' },
        n6102n: { i_: 10000, cp_: 1, sr_: [] },
        n7332n: { selectedrelatie: Number(companyId) || 0 },
        n24775n: { ...GRID_DEFAULTS, ob_: [{ n24792n: 'asc' }] },
        n21921n: { ...GRID_DEFAULTS },
        nd962e0d1n: { ...GRID_DEFAULTS },
        n89afc00bn: { ...GRID_DEFAULTS },
        n48947n: { entityfilter: null, typefilter: null },
        n20639n: { selectedemployee: { r_: '100' }, cp_: 1, i_: 12 },
        n6069n: { recordid: rid, o_: 'view', pinned: [], showpinnedonly: [] },
      },
      re_: 'n6073n',
    },
  };
  // UTF-8-veilige base64 (btoa faalt op niet-Latin1 tekens).
  const b64 = btoa(unescape(encodeURIComponent(JSON.stringify(state))));
  return `${GRIPP_BASE}?u=100#${b64}`;
}


// Gecontroleerd openen: Airtable-GrippID's kunnen naar verwijderde Gripp-records
// wijzen (witte pagina). We openen het tabblad synchroon (popup-blockers eisen
// een user-gesture) en sluiten het weer als de engine zegt dat het record weg is.
export async function openGrippGecontroleerd({ type, grippId, url, authFetch, aiEngineUrl, onWeg }) {
  if (!url) return;
  const tab = window.open('', '_blank');
  try {
    const r = await authFetch(`${aiEngineUrl}/api/v1/gripp/link-check?type=${type}&id=${encodeURIComponent(grippId)}`);
    const d = await leesJson(r, 'Gripp-link controleren');
    if (d && d.exists === false) {
      if (tab) tab.close();
      onWeg?.();
      return;
    }
  } catch { /* bewust stil: de link-check is best-effort, bij twijfel gewoon openen */ }
  if (tab) tab.location = url;
  else window.open(url, '_blank');
}
